import { RefreshCw } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { useStandardAgentDisplayName } from "@/modules/standardAgent/useStandardAgentDisplayName";

/** Props for the ItemEditorConflictBanner component. */
interface ItemEditorConflictBannerProps {
  onLoadTheirChanges: () => void;
  onKeepMyChanges: () => void;
}

/**
 * Banner shown when the item was updated in the background while the user has
 * unsaved edits, offering to load the new version or keep the local edits.
 */
export function ItemEditorConflictBanner({
  onLoadTheirChanges,
  onKeepMyChanges,
}: ItemEditorConflictBannerProps) {
  const agentName = useStandardAgentDisplayName();

  return (
    <Alert className="mb-4">
      <RefreshCw className="h-4 w-4" />
      <AlertTitle>{agentName} updated this item</AlertTitle>
      <AlertDescription>
        <p>
          This item changed while you were editing. Load the latest version, or
          keep your edits and only save the fields you touched.
        </p>
        <div className="mt-2 flex flex-wrap gap-2">
          <Button size="sm" variant="outline" onClick={onLoadTheirChanges}>
            Load {agentName}&apos;s changes
          </Button>
          <Button size="sm" variant="outline" onClick={onKeepMyChanges}>
            Keep mine
          </Button>
        </div>
      </AlertDescription>
    </Alert>
  );
}
